import type { appConfig } from "../types/app/appConfig"

const initalAppConfig:appConfig = {
    language: "",
    apiKey: "",
    apiUrl: ""
};

export { initalAppConfig };
